function initDiamondShape(selectedRing, selectedRingInfo) {
    const params = new URLSearchParams(window.location.search);
    const searchShape = params.get('shape') ? params.get('shape').toLowerCase()              // 全转小写
        .split(' ')                          // 按空格分割为单词数组
        .map(word =>
            word.charAt(0).toUpperCase() +     // 首字母大写
            word.slice(1)                      // 保留剩余字母
        )
        .join(' ') : '';
    if (ringsOptionsMaps.shape[searchShape]) {
        $(`.js_filter_option[data-text=${searchShape}]`).eq(0).trigger('click')
    } else if (selectedRing) {
        $(`.js_filter_option[data-text=${selectedRingInfo.option3}]`).eq(0).trigger('click')
    }
}
